import { ApiError, createApiClient, NetworkError } from '@dovefiniscono/api-client';
import type { ErrorKind } from '@dovefiniscono/sync';

export const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8787';

export const api = createApiClient({ baseUrl: API_URL, platform: 'web' });

/** Server messages are already in Italian; only transport failures need a text here. */
export function errorMessage(error: unknown): string {
  if (error instanceof NetworkError)
    return 'Sei offline o il server non risponde. Riprova tra poco.';
  if (error instanceof ApiError) return error.message;
  return 'Qualcosa non ha funzionato. Riprova.';
}

/** Codes the API puts in /login?error=… after a Google/Apple sign-in. */
export const oauthErrorMessages: Record<string, string> = {
  oauth_cancelled: 'Accesso annullato.',
  oauth_email_unverified: "Il tuo account non ha un'email verificata: usa email e password.",
  oauth_failed: 'Accesso non riuscito. Riprova.',
};

export function classifySyncError(error: unknown): ErrorKind {
  if (error instanceof NetworkError) return 'offline';
  if (error instanceof ApiError && error.status === 401) return 'unauthorized';
  return 'error';
}
